import { ViewModel,View, ViewModelMessage } from "binder"
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { ChangeThemeMessage } from "src/common/mainWindow/mainWindow-viewModel";
import  { AuthenticationView } from "./authentication-view"
import moment from "moment";
import { warehouseLocationMultiSelectorViewModel } from "src/Warehouse/warehouseLocationManipulation/warehouseLocationManipulation-viewModel";
declare var authenticationDebugDefaultUserName:string;
declare var authenticationDebugDefaultPassword:string;

export class AuthenticationViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    
        this.isCredentialsWrong = false;
        CurrentCredentials.username = '4';
        CurrentCredentials.password = '4';
        this.username = authenticationDebugDefaultUserName ?? "";
        this.password = authenticationDebugDefaultPassword ?? "";
        this._isLoggedIn = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new AuthenticationView();
    }
    public getTypeId(): string {
        return "VM-583F0A88-F7F4-4DF1-A0BB-CDD93FCC3702"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set isCredentialsWrong(v: boolean) { this._isCredentialsWrong = v; } public get isCredentialsWrong(): boolean { return this._isCredentialsWrong;} private _isCredentialsWrong: boolean;
    private _isLoggedIn : boolean;
    async login(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServerWithUsernameAndPassword('/Complex/AuthenticationServices/Login',{},this.username,this.password,[]);
            if(result.IsSuccessful){
                CurrentCredentials.username = this.username;
                CurrentCredentials.password = this.password;
                CurrentCredentials.personnelFullName = result.FullName;
                CurrentCredentials.personnelCode = result.UserCode;
                CurrentCredentials.fiscalPeriodStart = result.FiscalPeriodStart == null ? null : moment.utc(result.FiscalPeriodStart);
                if(this._isLoggedIn==false){
                    this._isLoggedIn = true;                
                    this.handleMessage(new LoginCompletedMessage());
                }
		        let themeId = result.CurrentTheme;
                let changeThemeRequest = new ChangeThemeMessage();
                changeThemeRequest.background = themeId;
                changeThemeRequest.shallSave = false;
                this.handleMessage(changeThemeRequest);
            }else{
                this.isCredentialsWrong = true;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class LoginCompletedMessage extends ViewModelMessage{

}
